// A kernel's external requirements, DERIVED from its steps (never hand-
// declared, so they can't drift from what the kernel actually calls —
// the same principle as deriving scope-eligibility from a query's root
// entity). Today the only requirement is MCP connectivity: a kernel with
// an `mcp_tool` step that calls `linear` needs the Linear connection.
//
// Used to gate visibility: an unsatisfiable kernel is never offered or
// rendered, so it never hits a missing connection at run time (the
// graceful-failure story is "don't show it", mirroring canMountOnScope).

import { connectionStatus, listConnections } from "./mcp/index.js";

// Distinct MCP server ids referenced by the kernel's mcp_tool steps.
export function kernelRequiredServers(kernel) {
    const servers = new Set();
    for (const step of kernel?.steps || []) {
        if (step?.kind === "mcp_tool" && step.server) servers.add(step.server);
    }
    return [...servers];
}

// True when every server the kernel needs is in `connectedServerIds`.
// A kernel with no MCP steps is always satisfied. Pure — caller supplies
// the connected set so this stays testable and cheap to call in a filter.
export function kernelRequirementsMet(kernel, connectedServerIds) {
    const required = kernelRequiredServers(kernel);
    if (!required.length) return true;
    const connected = new Set(connectedServerIds || []);
    return required.every((s) => connected.has(s));
}

// Resolve the connected MCP server ids for a tenant from the registry.
// A record that is saved but not signed in (or has lapsed) is not a
// connection the kernel could call.
export function connectedServerIds(tenantId) {
    if (!tenantId) return [];
    return listConnections(tenantId)
        .filter((c) => connectionStatus(c, c.connection) === "connected")
        .map((c) => c.id);
}
